













































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  Question,
  newQuestion,
  getQuestions,
  getAnswers,
  deleteAnswer,
  updateAnswer,
  createAnswer,
  Answer
} from "@/api/minutes-api";
import AnswerFormData from "@/api/models/AnswerFormData";
import { FolderEntry, Breadcrumb } from "@/models/file";
import FileExplorer from "@/templates/FileExplorer.vue";
import uuid from "uuid";

@Component({
  components: {
    FileExplorer
  }
})
export default class MinuteListPage extends Vue {
  @Prop({ required: true }) projectId!: string;

  target = uuid();
  selected: Question = newQuestion();
  answers: Answer[] = [];
  questions: Question[] = [];
  entries: FolderEntry[] = [];
  breadcrumbs: Breadcrumb[] = [{ id: 0, name: "議事録" }];
  inEdit = false;

  get permissions(): string[] {
    return this.$store.getters.permissions;
  }

  canWriteMinutes() {
    return (
      this.permissions.includes("service/project_operation") ||
      this.permissions.includes("project/document_secret") ||
      (this.permissions.includes("project/task_operation") &&
        this.permissions.includes("service/master_read") &&
        this.permissions.includes("project/minutes_operation"))
    );
  }

  private created() {
    this.initQuestions();
    this.initEntries();
  }
  private goEditPage(id: string) {
    const params = {
      projectId: this.projectId,
      answerId: id
    };
    this.$router.push({ name: "minute-edit", params });
  }
  private goShowPage(entry: FolderEntry) {
    const params = {
      projectId: this.projectId,
      answerId: String(entry.entryId)
    };
    this.$router.push({ name: "minute-show", params });
  }

  open(entry: FolderEntry) {
    switch (entry.kind) {
      case "file":
        this.goShowPage(entry);
        break;
    }
  }

  async rename(entry: FolderEntry, name: string) {
    const a_id = entry.entryId;
    const rename_answer = this.answers.find(r => String(r.id) === String(a_id));
    if (rename_answer == undefined) return;
    rename_answer.title = name;
    const data = AnswerFormData(rename_answer);
    await updateAnswer(data);
    this.initEntries();
  }

  private async createAnswer(questionId: number) {
    const create = await createAnswer(questionId, this.projectId);
    const params = {
      projectId: this.projectId,
      answerId: create.id
    };
    this.$router.push({ name: "minute-edit", params });
  }

  private async initEntries() {
    this.answers = await getAnswers(this.projectId);
    let entries: FolderEntry[] = [];
    this.answers.forEach(a => {
      const entry: FolderEntry = {
        entryId: a.id,
        kind: "file",
        name: a.title,
        image: require("@/assets/report-lg.png"),
        parentFolderId: 0,
        updated: new Date(a.updated)
      };
      entries.push(entry);
    });
    this.entries = entries;
  }

  private async initQuestions() {
    this.questions = await getQuestions(this.projectId);
    this.selected = this.questions[0];
  }

  async remove(entry: FolderEntry) {
    await deleteAnswer(entry.entryId);
    await this.initEntries();
  }
}
